import React, {ReactElement} from 'react';
import {useIntl} from 'react-intl';
import {cx} from '@emotion/css';
import {ReactComponent as TwitterIcon} from '@fo/shared-images/icons/social/twitter.svg';
import DynamicLink from '@fo/components/DynamicLink/DynamicLink';

import styles from './SocialShare.styles';

interface Props {
  urlToShare: string;
  textToShare?: string;
}

function Twitter({urlToShare, textToShare}: Props): ReactElement {
  const {formatMessage} = useIntl();
  const baseTwitterUrl = `https://twitter.com/intent/tweet?original_referer=${urlToShare}&url=${urlToShare}&source=tweetbutton`;
  const twitterUrl = textToShare ? `${baseTwitterUrl}&text=${textToShare}` : baseTwitterUrl;

  return (
    <DynamicLink className={cx(styles.link, 'unstyledLink')} testId="ui.social.twitter" href={twitterUrl} blank>
      <TwitterIcon title={formatMessage({id: 'social.share.twitter'})} />
    </DynamicLink>
  );
}

export default Twitter;
